var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["loyalty-success-content.j2"] = require( "loyalty-success-content.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["loyalty/templates/loyalty-modal-success.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "loyalty/templates/loyalty-modal-success.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("staticUrl")) {
var t_4 = t_1.staticUrl;
} else {
cb(new Error("cannot import 'staticUrl'")); return;
}
context.setVariable("staticUrl", t_4);
output += "<div class=\"o-row\">\n    <div class=\"o-column o-extra-small--12 o-small--10 o-large--8 o-small--centered o-large--centered u-centered-content c-modal-loyalty__success-container\" data-qa-loyalty-modal-success>\n\n        <h1 class=\"c-modal-loyalty__h1\">\n            <img class=\"c-modal-loyalty__logo\" src=\"";
output += runtime.suppressValue((lineno = 6, colno = 62, runtime.callWrap(t_4, "staticUrl", context, ["/images/modal/anthro-perks-logo.svg"])), env.opts.autoescape);
output += "\" />\n        </h1>\n\n        ";
if((lineno = 9, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.loyaltyForm.landingPage"]))) {
output += "\n            ";
env.getTemplate("loyalty-success-content.j2", false, "loyalty/templates/loyalty-modal-success.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n        ";
})});
}
output += "\n\n        <hr class=\"c-modal-loyalty__hr\"></hr>\n\n        <p class=\"c-modal-loyalty__p c-modal-loyalty__p--success\">\n            ";
output += runtime.suppressValue(env.getFilter("markdown_nowrap").call(context, (lineno = 16, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["loyalty_success-message-link"]))), env.opts.autoescape);
output += "\n        </p>\n\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["loyalty/templates/loyalty-modal-success.j2"] , dependencies)